/**
 * 前台应用入口。
 *
 * 挂载完成后移除 HTML 中的首屏骨架 —— 骨架在 JS 下载期间提供结构线框，
 * 应用就绪后必须让位，否则会与真实内容叠加。
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './shell/router'
import './styles/main.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)

// 错误边界：单个组件渲染失败降级为可见提示，而不是整树卸载后的白屏
app.config.errorHandler = (err, _instance, info) => {
  console.error('[portal] 未捕获的组件错误', info, err)
}

app.mount('#app')

document.getElementById('portal-boot')?.remove()
